import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41f127cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "box",
  style: {}
}
const _hoisted_2 = {
  key: 0,
  class: "empty"
}
const _hoisted_3 = {
  key: 1,
  style: {"margin":"16px 24px","display":"flex","flex-flow":"row","align-items":"flex-start"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "toolBox" }
const _hoisted_6 = { class: "toolBoxHeader" }
const _hoisted_7 = { class: "tboxItem" }
const _hoisted_8 = { class: "tboxItem" }
const _hoisted_9 = { class: "tboxItem" }
const _hoisted_10 = { class: "tboxItem" }
const _hoisted_11 = {
  key: 0,
  class: "tboxItem"
}
const _hoisted_12 = { class: "tboxItem" }
const _hoisted_13 = { class: "tboxItem" }
const _hoisted_14 = {
  name: "fileImg",
  style: {"display":"inline-block"}
}
const _hoisted_15 = { style: {"width":"100%","margin-left":"24px"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { style: {"background-color":"var(--light-background-color)"} }, [
  /*#__PURE__*/_createElementVNode("td", null, "文件名"),
  /*#__PURE__*/_createElementVNode("td", null, "大小"),
  /*#__PURE__*/_createElementVNode("td", null, "格式"),
  /*#__PURE__*/_createElementVNode("td", null, "宽高"),
  /*#__PURE__*/_createElementVNode("td", null, "日期"),
  /*#__PURE__*/_createElementVNode("td", null, "状态"),
  /*#__PURE__*/_createElementVNode("td", null, "操作")
], -1))
const _hoisted_17 = ["href"]

import { toBase64 } from "@/libs/util"
import Vue3DraggableResizable from 'vue3-draggable-resizable'
import { appStore } from '@/store/appStore';
import { computed, onMounted, reactive, ref, shallowRef, Ref, nextTick } from 'vue';
import JSZip from "jszip";
import { useObjectUrl, useDraggable } from '@vueuse/core';
interface fileItem {
	size: number,
	name: string,
	suffix: string,
	nosuffixName: string,
	type: string,
	width: number,
	height: number,
	scale: number,
	scale_width: number,
	scale_height: number,
	/** 填充方式，当大小不一致时
	 * fill拉申填充，cover居中裁剪图片至适合大小。contain完全展现到裁剪框中，但会有两白或者上下白边。
	 */
	cover: "fill" | "cover" | "contain",
	time: string,
	/** 待处理，失败，处理成功 */
	status: string,
	url: string,
	file: any,
	zhiliang: number,
	data:any
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PageListSet',
  setup(__props) {

_useCssVars(_ctx => ({
  "1d2b0ba2": (_ctx.imganiDur)
}))

const imageWorker = new Worker('/pkg/tmui_xz_worker.js');

const loading = ref(false);
const imgFormatList = ["jpg", "jpeg", "png", "gif", "bmp", "ico", "tiff"]
const imgopts = reactive({
	realWidth: 0,
	realHeight: 0,
	lockScale: true,
	zhiliang: 100,
	formart: "jpeg",
	isCovert: false
})

const dataType = ref('Text') as Ref<'Text' | 'ArrayBuffer' | 'Blob'>
const nowFiles = ref<fileItem[]>([]);
async function getTheFile() {
	// Open file picker and destructure the result the first handle
	const files = await window.showOpenFilePicker({
		dataType,
		multiple: true,
		types: [{
			description: '选择图片',
			accept: {
				'images/*': ['.jpg', '.jpeg', '.png', '.gif', '.tiff', '.bmp', '.ico'],
			},
		}],
		excludeAcceptAllOption: true,
	});

	// const fileData = await files[0].getFile();

	var index = 0;
	const nowFilesNames = nowFiles.value.map(el => el.name);
	const fileslist = files.filter(el => !nowFilesNames.includes(el.name));
	if (fileslist.length == 0) return;
	loading.value = true;

	function getFileInfo() {
		if (index >= fileslist.length) {
			loading.value = false;
			//文件排序。
			const sortdesc = nowFiles.value.sort((a, b) => b.size - a.size);
			nowFiles.value = [...sortdesc]
			return;
		}
		fileslist[index].getFile().then(res => {
			var imgObj = new Image();
			const url = useObjectUrl(res).value;
			imgObj.src = url;
			imgObj.onload = () => {
				const { width, height } = imgObj;
				nowFiles.value.push({
					size: res.size,
					name: res.name,
					type: res.type,
					width,
					height,
					nosuffixName: res.name.substring(0, res.name.lastIndexOf(".")),
					suffix: res.name.substring(res.name.lastIndexOf(".") + 1).toLocaleLowerCase(),
					scale: 0,
					scale_height: 0,
					scale_width: 0,
					cover: 'fill',
					time: returnDate(res.lastModified),
					status: "待处理",
					url: url,
					file: res,
					zhiliang: 100,
					data:[]
				})
				imgObj.remove()
				index += 1;
				getFileInfo();
			}
		}).catch(e => {
			console.error(e);
			index += 1;
			getFileInfo();
		})

	}
	getFileInfo();
}

function returnDate(d: number) {
	const dt = new Date(d);
	return dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate()
}
const imgSizeCovert = (size: number) => {
	if (!size) return "0b";
	if (size < 1024 * 1000) return (size / 1024).toFixed(2) + "KB";
	if (size < 1024 * 1024 * 1024) return (size / 1024 / 1024).toFixed(2) + "MB";
	return (size / 1024 / 1024 / 1024).toFixed(2) + "GB";
}
function removeFile(index?: number) {
	if (typeof index != 'number') {
		nowFiles.value = [];
		console.log(nowFiles.value)
	} else {
		nowFiles.value.splice(index, 1)
	}
}

function lockScallBlv(e) {
	imgopts.lockScale = e.srcElement.ariaChecked == 'true' ? true : false;
}
function changeCover(e) {
	imgopts.isCovert = e.srcElement.ariaChecked == 'true' ? true : false;
}

function selectedImgFormart(fkey: string) {
	imgopts.formart = fkey;
}
function zhiliangSliedreChange(e) {
	let zl = parseInt(e.srcElement.value);

	imgopts.zhiliang = Math.min(100, zl)
	imgopts.zhiliang = Math.max(0, zl)
}
function heightChangeend(e, type: string) {
	var imgw = 0;
	var imgh = 0;
	// if(imgopts.realHeight==0||imgopts.realWidth==0) return;

	if (type == "w" && imgopts.lockScale) {
		imgopts.realWidth = Number(e.srcElement.value)
		imgopts.realHeight = 0
		return;
	}
	if (type == "h" && imgopts.lockScale) {
		imgopts.realHeight = Number(e.srcElement.value)
		imgopts.realWidth = 0
		return;
	}
	if (type == 'w') {
		imgw = Number(e.srcElement.value);

		if (imgopts.lockScale) {
			imgh = imgw * imgopts.realHeight / imgopts.realWidth
		} else {
			imgh = imgopts.realHeight
		}

	} else {
		imgh = Number(e.srcElement.value);
		if (imgopts.lockScale) {
			imgw = imgopts.realWidth * imgh / imgopts.realHeight
		} else {
			imgw = imgopts.realWidth
		}
	}
	imgopts.realWidth = Math.floor(imgw)
	imgopts.realHeight = Math.floor(imgh)
}

async function chuli() {
	if(loading.value) return;
	var ftemsList = nowFiles.value.map(el => {
			let width = el.scale_width;
			let height = el.scale_height;
			let formart = el.suffix;
			if (imgopts.isCovert) {
				formart = imgopts.formart;
			}
			if (imgopts.realWidth == 0 && imgopts.realHeight == 0) {
				width = el.width;
				height = el.height;
			}
			if (imgopts.realHeight > 0 && imgopts.realWidth > 0 && !imgopts.lockScale) {
				width = imgopts.realWidth;
				height = imgopts.realHeight;
			}
			if (imgopts.lockScale && imgopts.realWidth > 0) {
				width = imgopts.realWidth;
				height = width * el.height / el.width
			}
			if (imgopts.lockScale && imgopts.realHeight > 0) {
				height = imgopts.realHeight;
				width = el.width * height / el.height
			}
			return {
				...el,
				scale_width: Math.floor(width),
				scale_height: Math.floor(height),
				suffix: formart,
				status: '处理中',
				zhiliang: imgopts.zhiliang
			}
		})
	
	nowFiles.value = [...ftemsList];
	loading.value = true;
	var index = 0;
	let item = ftemsList[index];

	async function chuliFn(){
		item = ftemsList[index];
		imageWorker.postMessage({
			name: "cpos_img",
			data: [
				await toBase64(item.file), 
				item.type, 
				item.scale_width, 
				item.scale_height, 
				item.zhiliang, 
				0, 
				item.suffix
			]
		})
	}

	function oksuccess(){
		var zip = new JSZip();
		ftemsList.forEach(el=>{
			zip.file(el.nosuffixName+ "." + el.suffix, el.data, { binary: true });
		})

		zip.generateAsync({ type: "blob" })
		.then(async function (content) {
			const psHandle = await window.showSaveFilePicker({
				dataType: "ArrayBuffer",
				types: [{
					description: '保存图像文件',
					accept:{
						"*/*":[".zip"]
					}
				}],
				suggestedName:"IMAGEBOX-TMUI.zip",
				excludeAcceptAllOption: true,
			}).catch(e=>{
				ftemsList = [];
				zip = null;
				loading.value = false;
			})
			if(!psHandle) return;
			
			const writable = await psHandle.createWritable()
			if(!writable) return;
			await writable.write(content);
			await writable.close();
			loading.value = false;
		});


	}


	imageWorker.onmessage = async (e) => {
		if (e.data?.name == "cpos_img") {
			item.data = e.data.data;
			item.status = "完成";
			item.width = item.scale_width;
			item.height = item.scale_height;
			item.size = e.data.data.length;

			ftemsList.splice(index,1,item);
			let oks = ftemsList.map(el=>{
				return {...el,data:[]};
			})
			nowFiles.value = [...oks]
			index +=1;
			if(index >= nowFiles.value.length){
				
				oksuccess()
			}else{
				chuliFn()
			}
		}
		
	}


	chuliFn()
}


return (_ctx: any,_cache: any) => {
  const _component_x_throbber = _resolveComponent("x-throbber")!
  const _component_x_icon = _resolveComponent("x-icon")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_label = _resolveComponent("x-label")!
  const _component_x_box = _resolveComponent("x-box")!
  const _component_x_numberinput = _resolveComponent("x-numberinput")!
  const _component_x_switch = _resolveComponent("x-switch")!
  const _component_x_slider = _resolveComponent("x-slider")!
  const _component_x_menuitem = _resolveComponent("x-menuitem")!
  const _component_x_menu = _resolveComponent("x-menu")!
  const _component_x_select = _resolveComponent("x-select")!
  const _component_x_card = _resolveComponent("x-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_x_box, { style: {"display":"flex","justify-content":"flex-start","align-items":"center","flex-flow":"row wrap","padding":"16px 24px","background-color":"var(--light-background-color)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_x_button, {
          disabled: loading.value,
          toggled: "",
          onClick: getTheFile
        }, {
          default: _withCtx(() => [
            (loading.value)
              ? (_openBlock(), _createBlock(_component_x_throbber, {
                  key: 0,
                  small: "small"
                }))
              : (_openBlock(), _createBlock(_component_x_icon, {
                  key: 1,
                  href: "#ri-file-add-line"
                })),
            _createTextVNode(" 添加图片文件")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_x_button, {
          onClick: removeFile,
          style: {"margin-left":"8px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_x_icon, { href: "#ri-delete-bin-6-line" }),
            _createTextVNode(" 清空文件列表")
          ]),
          _: 1
        }),
        _createVNode(_component_x_label, { style: {"margin-left":"12px","opacity":"0.7"} }, {
          default: _withCtx(() => [
            _createTextVNode("程序是本地程序，不会把你的资料上传到任何服务器上，请绝对放心，本应用是离线应用。")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (nowFiles.value.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_x_button, {
            onClick: getTheFile,
            toggled: "",
            style: {"width":"100px","height":"100px","border-radius":"50%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_x_icon, {
                href: "#ri-folder-add-fill",
                style: {"width":"40px","height":"40px"}
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (nowFiles.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_x_card, {
            class: "tool",
            style: {"flex-shrink":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_x_label, {
                style: {"padding":"15px","font-size":"16px","font-weight":"bold"},
                ref: "el"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("操作菜单")
                ]),
                _: 1
              }, 512),
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_x_label, { style: {"margin-bottom":"10px"} }, {
                    default: _withCtx(() => [
                      _createTextVNode("宽高为0时，不会处理宽和高,一边为0时，锁定比例下会自动缩放。")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_x_label, { class: "title" }, {
                      default: _withCtx(() => [
                        _createTextVNode("宽度")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_x_numberinput, {
                      disabled: loading.value,
                      onChange: _cache[0] || (_cache[0] = ($event: any) => (heightChangeend($event, 'w'))),
                      value: imgopts.realWidth,
                      min: 0,
                      style: {"min-width":"138px","margin":"0px"}
                    }, null, 8, ["disabled", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_x_label, { class: "title" }, {
                      default: _withCtx(() => [
                        _createTextVNode("高度")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_x_numberinput, {
                      disabled: loading.value,
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (heightChangeend($event, 'h'))),
                      value: imgopts.realHeight,
                      min: 0,
                      style: {"min-width":"138px","margin":"0px"}
                    }, null, 8, ["disabled", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_x_label, { class: "title" }, {
                      default: _withCtx(() => [
                        _createTextVNode("锁定比例")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_x_switch, {
                      disabled: loading.value,
                      ariaChecked: imgopts.lockScale,
                      toggled: "",
                      onToggle: lockScallBlv
                    }, null, 8, ["disabled", "ariaChecked"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_x_label, { class: "title" }, {
                      default: _withCtx(() => [
                        _createTextVNode("图片质量")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_x_slider, {
                      disabled: loading.value,
                      style: {"width":"140px"},
                      onChange: zhiliangSliedreChange,
                      min: 30,
                      max: 100,
                      value: imgopts.zhiliang
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_x_label, { value: "30" }, {
                          default: _withCtx(() => [
                            _createTextVNode("差")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_x_label, { value: "64" }, {
                          default: _withCtx(() => [
                            _createTextVNode("中")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_x_label, { value: "100" }, {
                          default: _withCtx(() => [
                            _createTextVNode("好")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled", "value"])
                  ]),
                  (imgopts.isCovert)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_x_label, { class: "title" }, {
                          default: _withCtx(() => [
                            _createTextVNode("保存格式")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_x_select, {
                          disabled: loading.value,
                          style: {"width":"138px"},
                          value: imgopts.formart
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_x_menu, null, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imgFormatList, (item, index) => {
                                  return _createVNode(_component_x_menuitem, {
                                    key: index,
                                    onClick: ($event: any) => (selectedImgFormart(item)),
                                    value: item
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_x_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "value"])
                                }), 64))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled", "value"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_x_label, { class: "title" }, {
                      default: _withCtx(() => [
                        _createTextVNode("转换格式")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_x_switch, {
                      disabled: loading.value,
                      ariaChecked: imgopts.isCovert,
                      onToggle: changeCover
                    }, null, 8, ["disabled", "ariaChecked"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, [
                      _createVNode(_component_x_button, {
                        disabled: loading.value,
                        style: {"width":"227px"},
                        onClick: chuli,
                        toggled: ""
                      }, {
                        default: _withCtx(() => [
                          (loading.value)
                            ? (_openBlock(), _createBlock(_component_x_throbber, {
                                key: 0,
                                small: "small"
                              }))
                            : (_openBlock(), _createBlock(_component_x_icon, {
                                key: 1,
                                href: "#ri-terminal-line"
                              })),
                          _createVNode(_component_x_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode("开始批量处理")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ]),
                  _createVNode(_component_x_label, { style: {"margin-top":"10px"} }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存是保存到你计算机磁盘上。")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("table", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nowFiles.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  style: _normalizeStyle({ backgroundColor: (index + 2) % 2 ? 'var(--light-background-color)' : 'none', height: '36px' })
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.nosuffixName), 1),
                  _createElementVNode("td", null, _toDisplayString(imgSizeCovert(item.size)), 1),
                  _createElementVNode("td", null, _toDisplayString(item.suffix), 1),
                  _createElementVNode("td", null, _toDisplayString(item.width) + "x" + _toDisplayString(item.height), 1),
                  _createElementVNode("td", null, _toDisplayString(item.time), 1),
                  _createElementVNode("td", {
                    style: _normalizeStyle({color:item.status=='完成'?'var(--accent-color)':'auto'})
                  }, _toDisplayString(item.status), 5),
                  _createElementVNode("td", null, [
                    _createVNode(_component_x_box, null, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          href: item.url,
                          target: "_blank"
                        }, [
                          _createVNode(_component_x_button, { toggled: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_x_icon, { href: "#ri-seedling-line" }),
                              _createTextVNode(" 预览")
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_17),
                        _createVNode(_component_x_button, {
                          onClick: ($event: any) => (removeFile(index)),
                          style: {"margin-left":"8px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_x_icon, { href: "#ri-delete-bin-6-line" }),
                            _createTextVNode(" 移除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 4))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})